import { memoize } from 'utils/common';

import { getTripEventsMinDate } from './utils';

export const tripEventsSelector = (state) => state.itinerariesItem.tripEvents;
export const collapsedDaysSelector = (state) => state.itinerariesItem.collapsedDays;
export const tripEventSelector = memoize((id) => (state) => state.itinerariesItem.tripEvents.find((t) => t.id === id));
export const startDateSelector = (state) => getTripEventsMinDate(state.itinerariesItem.tripEvents);
